import { Fab, Tooltip, useTheme } from '@mui/material';
import Iconify from './Iconify';

interface Props {
  title: string;
  bg?: string;
  size?: number;
}

const CustomTooltip: React.FC<Props> = ({ title, bg, size = 20 }) => {
  const theme = useTheme();

  if (!title) {
    return null;
  }

  return (
    <Tooltip placement="top" title={title}>
      <Fab
        size="small"
        sx={{
          minHeight: size,
          height: size,
          width: size,
          backgroundColor: bg || theme.palette.primary.main,
          '&:hover': { backgroundColor: bg || theme.palette.primary.main },
          mb: 0.3,
          mx: 0.5,
        }}
      >
        <Iconify
          icon={'material-symbols:exclamation'}
          width={18}
          height={18}
          sx={{ transform: 'rotate(180deg)' }}
        />
      </Fab>
    </Tooltip>
  );
};

export default CustomTooltip;
